module.exports = __webpack_public_path__ + "static/media/image-error-desktop-br.e0ea3159.jpg";